/**
 * Created by mh on 17/12/12
 */
import vue from 'vue';
import store from '@/store/index.js';
import router from '@/router/index.js';
import axios from 'axios';
import { getCookie, setCookie, removeCookie } from './utils';
import { baseUrl, wxORzfb } from './config';

axios.defaults.headers.post['Content-Type'] = 'application/json; charset=utf-8';
axios.defaults.baseURL = baseUrl
let loading = null;

function closeloading() {
  // let count = store.getters.loadingCount;
  // if (loading && count) {
  // 	count--;
  // 	store.dispatch('setLoadingCount', count);
  // 	!count && loading.close();
  // }
  // loading.close();
}

function showloading() {
  // loading = Loading.service();
  // store.dispatch('setLoadingCount', store.getters.loadingCount + 1);
}

axios.interceptors.request.use(config => {
  // let token = getCookie("token");
  var token = store.getters.token;
  if (!token) {
    token = getCookie("token");
  }
  if (token) {
    config.headers['token'] = token;
  }
  var authorizer_appid = getCookie('authorizer_appid') ? getCookie('authorizer_appid') : '';
  if (authorizer_appid) {
    config.headers["AuthorizerAppid"] = authorizer_appid;
  }
  var organId = getCookie('organId') ? getCookie('organId') : '';
  if (organId) {
    config.headers["organId"] = organId;
  }
  //console.log(config)
  return config;
}, error => {
  // console.log(error);
  return Promise.reject(error);
});

axios.interceptors.response.use(response => {
  return response;
}, error => {
  // console.log(error);
  return Promise.reject(error);
});

//检查响应
function checkResponse(response, option, resolve, reject) {

  let token = response.headers['token'];
  let data = response.data;
  if (token) {
    // setCookie("token", token);
    store.dispatch('saveToken', token);
  }
  !option.isHideLoading && closeloading();
  //如果没有，就跳转支付宝授权
  if ((data.Code == 202 || data.Code == 401) && !option.isIgnoreAuth) {
    store.dispatch('loginOut');
    store.dispatch('saveBackurl', option.backurl || router.currentRoute.fullPath);
    // router.replace({ name: 'tokenlogin' });
    // setCookie('redirect', location.href);
    var authorizer_appid = getCookie('authorizer_appid') ? getCookie('authorizer_appid') : '';
 
    // if(isAliOrWx() != 'wx' && isAliOrWx() != 'ali' ){
    //   window.location.href = baseUrl+"/#/JustWeAli";
    // } 

    var redirect = location.href;
    // if( redirect.indexOf('qr.') > -1 ){
    //直接处理跳转url
    if (isAliOrWx() == 'ali' && wxORzfb != 'zfb') {
      //不包含支付宝的
      window.location.href = redirect.replace(/(qr\.)|(wx\.)/, "zfb.");
      return;
    } else if (isAliOrWx() == 'wx' && wxORzfb != 'wx') {
      //不包含微信的
      window.location.href = redirect.replace(/(qr\.)|(zfb\.)/, "wx");
      return;
    }
    // }

    //处理菜鸟驿站跟城管局的跳转,安卓这里会丢失   http://wx.test.oouyan.cn/#/
    setCookie('redirect', redirect);
    if (redirect.indexOf('yueIndex') > -1 || redirect.indexOf('birdindex') > -1) {
      setCookie('yueBirdredirect', redirect);
    }
    if (redirect.indexOf('/#/yueIndex') > -1) {
      setCookie('yueredirect', redirect);
    }

    if (isAliOrWx() == 'wx') {
      //微信内核
      window.location.href = baseUrl + '/api/app/thirdPlatform/wxAuthLogin' + (authorizer_appid ? '?authorizer_appid=' + authorizer_appid : '');
    } else if (isAliOrWx() == 'ali') {
      //支付宝内核
      window.location.href = baseUrl + '/api/app/alipayThirdPlatform/AuthLogin' + (authorizer_appid ? '?authorizer_appid=' + authorizer_appid : '');
    }

    // if( wxORzfb == 'wx' ){
    //   window.location.href = baseUrl + '/api/app/thirdPlatform/wxAuthLogin' + (authorizer_appid ? '?authorizer_appid=' + authorizer_appid : '');
    //   //微信跳转授权
    // }else{
    //    window.location.href = baseUrl + '/api/app/alipayThirdPlatform/AuthLogin' + (authorizer_appid ? '?authorizer_appid=' + authorizer_appid : '');
    //   //支付宝跳转授权
    // }
  } else {

    if (option.isReturnApiResult) {
      resolve(data);
    } else {
      if (data.Code == 200) {
        // console.log(data);
        resolve(data);
      } else if (data.Code == 502) {
        if (!data.Content) {
          data.Content = {
            Confirm: true,
            Message: data.Message
          };
        }
        resolve(data.Content);
      } else {
        if (option.url.indexOf("/api/saveEarth/checkAddressPartner") > -1) {
          //附近合伙人不处理
          // vue.$vux.loading.hide()
        } else {
          vue.$vux.loading.hide()
          vue.$vux.toast.text(data.Message)
          reject(data);
        }
        // Toast.show({ text: data.Message })

        // vue.$toast(data.Message);
      }
    }
  }
}

//检查响应
function checkAlipayResponse(response, option, resolve, reject) {

  let token = response.headers['token'];
  let data = response.data;
  if (token) {
    // setCookie("token", token);
    store.dispatch('saveToken', token);
  }
  !option.isHideLoading && closeloading();
  //如果没有，就跳转支付宝授权
  if ((data.Code == 202 || data.Code == 401) && !option.isIgnoreAuth) {

  } else {

    if (option.isReturnApiResult) {
      resolve(data);
    } else {
      if (data.Code == 200) {
        // console.log(data);
        resolve(data);
      } else if (data.Code == 502) {
        if (!data.Content) {
          data.Content = {
            Confirm: true,
            Message: data.Message
          };
        }
        resolve(data.Content);
      } else {
        // Toast.show({ text: data.Message })
        vue.$vux.loading.hide()
        vue.$vux.toast.text(data.Message)
        // vue.$toast(data.Message);
        reject(data);
      }
    }
  }
}

function isAliOrWx() {
  // console.log( "授权3" )
  let typeBower = '';
  let browser = {
    versions: function () {
      let u = navigator.userAgent,
        app = navigator.appVersion;
      return { //移动终端浏览器版本信息
        trident: u.indexOf('Trident') > -1, //IE内核
        presto: u.indexOf('Presto') > -1, //opera内核
        webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
        gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
        mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
        android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或uc浏览器
        iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
        iPad: u.indexOf('iPad') > -1, //是否iPad
        webApp: u.indexOf('Safari') == -1 //是否web应该程序，没有头部与底部
      };
    }(),
    language: (navigator.browserLanguage || navigator.language).toLowerCase()
  };
  if (browser.versions.mobile) { //判断是否是移动设备打开。browser代码在下面
    // console.log( "授权4" )
    var ua = navigator.userAgent.toLowerCase(); //获取判断用的对象
    if (ua.match(/Alipay/i) == "alipay") {
      typeBower = 'ali';
    }
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      typeBower = 'wx';
    }
  }
  return typeBower;
}


export default {
  axios,
  post(option) {
    return new Promise((resolve, reject) => {
      !option.isHideLoading && showloading();
      axios.post(option.url, option.data, option.config).then(response => {
        if (option.url.indexOf('api/app/alipayThirdPlatform/appointmentLogin') > -1 || option.url.indexOf('api/app/alipayThirdPlatform/sendMobileCode') > -1) {
          //在使用支付宝的授权，发手机验证码，不走这一步
          checkAlipayResponse(response, option, resolve, reject);
        } else {
          checkResponse(response, option, resolve, reject);
        }
      }).catch(error => {
        !option.isHideLoading && closeloading();
        option.isReturnError && reject(error);
      });
    });
  },
  get(option) {
    return new Promise((resolve, reject) => {
      !option.isHideLoading && showloading();
      axios.get(option.url, option.config).then(response => {
        if (option.url == ("/shop/wxapp/news/getNews")) {
          if (response.data.Code == '200') {
            resolve(response.data)
          }
        } else {
          checkResponse(response, option, resolve, reject);
        }
      }).catch(error => {
        !option.isHideLoading && closeloading();
        option.isReturnError && reject(error);
      });
    });
  }
};



// WEBPACK FOOTER //
// ./src/common/js/http.js